<template>
  <div class="nf-drop" :style="{ width: width, height }">
    <DropdownMenu
      class="nf-drop_menu"
      active-color="rgb(172,185,232)"
      :style="{ width: width, height }"
      :direction="direction"
    >
      <DropdownItem
        class="nf-drop_menu_item"
        v-model="modelValue"
        :options="options"
      />
    </DropdownMenu>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem } from "vant";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: '.5rem'
    },
    direction: {
      type: String,
      default: "down",
    }
  },
  data() {
    return {};
  },
  components: {
    DropdownMenu,
    DropdownItem,
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.nf-drop {
  font-size: 12px;
  &_menu {
    &_item {
    }
  }
}

::v-deep .van-dropdown-menu__bar {
  height: 100%;
  border: 2px solid #ddd;
  border-radius: 0.5rem;
}

::v-deep .van-ellipsis {
  font-size: 0.2rem;
  color: #666666;
}
::v-deep .van-cell__title{
  font-size: 0.2rem;
}
</style>
